import Link from 'next/link';

import Logo from '~/components/common/Logo';
import Section from '~/components/hero/LandingPage/Section';
import MainNav from '~/components/navbar/MainNav';
import { TournamentReward } from '~/components/tournament/Reward';
import { OPENSEA_COLLECTION_URL } from '~/constants';

const Tournament = () => {
  return (
    <>
      <div className="container container--landing-page container--landing-page-tournament">
        <header className="landing-page__header">
          <MainNav showConnectWallet={false} />
        </header>
        <div className="content-wrapper">
          <Section className="landing-page__section--tournaments">
            <header className="tournament-header">
              <Logo filename="tournaments-logo.svg" alt="Tournaments" />
              <div className="tournament-battles">
                <div className="image-stack">
                  <div className="image-stack__item image-stack__item--top">
                    <img
                      src="/img/warriors/upgrades/brawler/0.gif"
                      alt="Brawler"
                    />
                  </div>
                  <div className="image-stack__item image-stack__item--bottom">
                    <img
                      src="/img/warriors/upgrades/the-don/0.gif"
                      alt="The Don"
                    />
                  </div>
                </div>
                {/* if tourney started uncomment */}
                <p>
                  Have a Warrior in the tournament?
                  <br /> Enter your attacks here:
                </p>
                <Link href="/tournaments/valentines/battles" passHref>
                  <button className="button" type="button">
                    Enter attacks
                  </button>
                </Link>
              </div>
            </header>
            <div className="tournament-sub-header tournament-cta">
              {/* if tourney started uncomment */}
              {/* <p className="landing-page__inter">
                Tournaments every two weeks, starting February 14th
              </p> */}
              <p className="landing-page__inter">
                {/* Tournaments started */}
                Tournaments every two weeks
                <br />
                One battle every week day
                <br />
                Signup to be automatically enrolled in upcoming tournaments
                {/* To join, get an active{' '}
                <a
                  href={OPENSEA_COLLECTION_URL}
                  className="link"
                  target={'_blank'}
                  rel="noreferrer"
                >
                  Peacefall Warrior
                </a>{' '}
                on OpenSea. */}
              </p>
              <div className="mb-space-l">
                {/* <a
                  href={OPENSEA_COLLECTION_URL}
                  className="link"
                  target={'_blank'}
                  rel="noreferrer"
                >
                </a> */}
                <Link href="/tournaments/signup" passHref>
                  <button className="button" type="button">
                    Signup now
                  </button>
                </Link>
              </div>
            </div>
            <TournamentReward />

            {/* <div className="button-row mb-space-l">
              <Link href="/tournaments/champions" passHref>
                <button className="button" type="button">
                  View Contestants
                </button>
              </Link>
            </div> */}

            <div className="button-row mb-space-l">
              <a
                href={OPENSEA_COLLECTION_URL}
                className="link"
                target={'_blank'}
                rel="noreferrer"
              >
                <button className="button tournament-cta-button" type="button">
                  Get Yours Now
                </button>
              </a>
            </div>
          </Section>
        </div>
      </div>
    </>
  );
};

export default Tournament;
